import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row rounded-2xl overflow-hidden">
          <div className="lg:w-1/2 relative min-h-[320px] md:min-h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Carefully%20curated%20collection%20of%20fashion%20essentials%20sneakers%20scarf%20bag%20and%20watch%20arranged%20vertically%20on%20light%20cream%20surface%20soft%20natural%20daylight%20from%20left%20editorial%20lifestyle%20photography%20clean%20elegant%20composition%20warm%20camel%20and%20ivory%20palette&width=900&height=600&seq=cta-main-img&orientation=portrait"
              alt="Pandabuy spreadsheet products collection"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
            <div className="absolute top-6 left-6">
              <span className="text-xs uppercase tracking-wider text-white/80 font-label bg-black/20 backdrop-blur-sm px-3 py-1 rounded-full">
                Trusted Source
              </span>
            </div>
            <div className="absolute bottom-8 left-8">
              <h3 className="font-heading text-3xl md:text-4xl text-white leading-tight">
                Ready to Explore<br />Pandabuy Spreadsheets?
              </h3>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center text-center px-6 md:px-12 py-12 md:py-16">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight mb-4">
              Pandabuy Sheet<br />Buy It Now
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-sm leading-relaxed mb-8">
              Access the most updated Pandabuy spreadsheet collections. Browse thousands of verified finds across sneakers, streetwear, tech gadgets, and luxury items — all organized for fast discovery.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Pandabuy Sheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}